var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"genres"},_vm._l((_vm.genres),function(genre){return _c('div',{key:genre.id},[_c('div',{staticClass:"genre"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm._f("genreName")(genre)))])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }